export type FormValue = string | number | boolean | null;

export type FormState = Record<string, FormValue>;

export type UiFieldType =
  | 'checkbox'
  | 'radio'
  | 'number'
  | 'dropdown'
  | 'date'
  | 'folderPicker'
  | 'dynamicDropdown'
  | 'modeSlider';

export interface UiFieldOption {
  value: string;
  label: string;
}

export interface UiFieldRange {
  min: number;
  max: number;
  step?: number;
}

export interface UiField {
  section: string;
  label: string;
  type: UiFieldType;
  tooltip?: string;
  description?: string;
  required?: boolean;
  options?: UiFieldOption[];
  default?: FormValue;
  dependencies?: string[];
  range?: UiFieldRange;
  placeholder?: string;
}

const removeAccents = (value: string): string =>
  value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const buildStateKey = (section: string, label: string): string =>
  removeAccents(`${section}_${label}`)
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, '');
